import React, { useState } from "react";
import "./WhyUs.css";
import { motion } from "framer-motion";

const features = [
  { title: "Expertise in Educational Content", icon: "📖" },
  { title: "End-to-End Solutions", icon: "🔄" },
  { title: "Commitment to Quality", icon: "✔️" },
  { title: "On-Time Delivery", icon: "⏱️" },
];

const mediaImage =
  "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=800&q=80";

const WhyUs = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleCardClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section className="whyus-section">
      <div className="ticker-wrapper">
        <div className="ticker">
          • Latest Trends • Quality Content • Smart Production • Precision
          Delivery • Creative Storytelling • Media Excellence
        </div>
      </div>

      <div className="whyus-container">
        <div className="content-box">
          <div className="left-text">
            <motion.h2
              initial={{ x: -50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.6 }}
              className="uvs-media-css"
            >
              Why is <span className="highlight-uv">UV MEDIA </span>
              the first choice for leading publishers?
            </motion.h2>
            <motion.p
              className="description"
              initial={{ x: -50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ delay: 0.2, duration: 0.6 }}
            >
              We are a team of passionate educationists committed to delivering
              high-quality content, from design to digitization. Our end-to-end
              production ensures timely delivery with precision, creativity, and
              consistency—every single time.
            </motion.p>
            <motion.h4
              className="subheading"
              initial={{ x: -50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.6 }}
            >
              THE FOUR KEY DRIVERS OF OUR CONTINUED EXCELLENCE.
            </motion.h4>
          </div>

          <motion.div
            className="right-image"
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
          >
            <img src={mediaImage} alt="Media team collaboration" />
          </motion.div>
        </div>

        <div className="features-box">
          {features.map((feature, idx) => (
            <motion.div
              key={idx}
              className={`feature-card ${activeIndex === idx ? "active" : ""}`}
              onClick={() => handleCardClick(idx)}
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.4 + idx * 0.1, duration: 0.5 }}
            >
              <div className="icon">{feature.icon}</div>
              <p>{feature.title}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
